import React from 'react';

export default function DeliveryInfo({ formData, setFormData }) {
  const handleDeliveryMethodChange = (method) => {
    setFormData(prev => ({
      ...prev,
      deliveryMethod: method,
      shippingAddress: method === 'pickup' ? null : prev.shippingAddress
    }));
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      shippingAddress: {
        ...prev.shippingAddress || {},
        [name]: value
      }
    }));
  };

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-xl font-semibold text-cyan-500 mb-6">
          Delivery Options
        </h2>
        <p className="text-gray-400 mb-8">
          Choose how you'd like to receive your order.
        </p>
      </div>

      <div className="space-y-6">
        <div className="bg-gray-800 p-4 rounded-lg">
          <div className="flex space-x-8">
            <label className="flex items-center">
              <input
                type="radio"
                name="deliveryMethod"
                value="pickup"
                checked={formData.deliveryMethod === 'pickup'}
                onChange={() => handleDeliveryMethodChange('pickup')}
                className="text-cyan-500 focus:ring-cyan-500"
              />
              <span className="ml-2 text-gray-300">Local Pickup</span>
            </label>

            <label className="flex items-center">
              <input
                type="radio"
                name="deliveryMethod"
                value="shipping"
                checked={formData.deliveryMethod === 'shipping'}
                onChange={() => handleDeliveryMethodChange('shipping')}
                className="text-cyan-500 focus:ring-cyan-500"
              />
              <span className="ml-2 text-gray-300">FREE Delivery</span>
            </label>
          </div>
        </div>

        {formData.deliveryMethod === 'pickup' && (
          <div className="bg-gray-700 p-6 rounded-lg">
            <h4 className="font-medium text-cyan-500 mb-2">Pickup Location:</h4>
            <p className="text-gray-300">Highline Motorsports Group</p>
            <p className="text-gray-300">768 State Route 50</p>
            <p className="text-gray-300">Burnt Hills NY 12027</p>
            <p className="text-gray-300 mt-2">Available Mon-Fri between 9am to 5pm</p>
          </div>
        )}

        {formData.deliveryMethod === 'shipping' && (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div className="bg-gray-800 p-4 rounded-lg">
              <label className="block text-sm font-medium text-gray-300">
                Street Address
              </label>
              <input
                type="text"
                name="street"
                value={formData.shippingAddress?.street || ''}
                onChange={handleAddressChange}
                className="mt-2 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-cyan-500 focus:ring-cyan-500 px-3 py-2"
              />
            </div>

            <div className="bg-gray-800 p-4 rounded-lg">
              <label className="block text-sm font-medium text-gray-300">
                City
              </label>
              <input
                type="text"
                name="city"
                value={formData.shippingAddress?.city || ''}
                onChange={handleAddressChange}
                className="mt-2 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-cyan-500 focus:ring-cyan-500 px-3 py-2"
              />
            </div>

            <div className="bg-gray-800 p-4 rounded-lg">
              <label className="block text-sm font-medium text-gray-300">
                State
              </label>
              <input
                type="text"
                name="state"
                value={formData.shippingAddress?.state || ''}
                onChange={handleAddressChange}
                className="mt-2 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-cyan-500 focus:ring-cyan-500 px-3 py-2"
              />
            </div>

            <div className="bg-gray-800 p-4 rounded-lg">
              <label className="block text-sm font-medium text-gray-300">
                ZIP Code
              </label>
              <input
                type="text"
                name="zip"
                value={formData.shippingAddress?.zip || ''}
                onChange={handleAddressChange}
                className="mt-2 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-cyan-500 focus:ring-cyan-500 px-3 py-2"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}